import React, { useState, useRef, useEffect, forwardRef } from 'react';
import { Button, Form, Select, Flex, Space, InputNumber, Tag, message } from 'antd';
import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons';
import { getList as getPeriodos, getDetailsById as getDetailsByPeriodId } from '../../apis/PeriodosApi';
import { status_period } from '@app/constants/period';
import useCookies from "../../hooks/useCookies";
// import PeriodStatus from '@app/components/common/PeriodStatus';
import _ from 'lodash';
import moment from 'moment';

const { Option } = Select;
const AnioPeriodo = forwardRef(function AnioPeriodo({ onBlur, setLoadingData, getPeriodDetail, getPeriodDetails, values, form, disabledForm, reset }, ref) {
    const [initialValues, setInitialValues] = useState(values);
    const [tiposPeriodo, setTiposPeriodo] = useState([]);
    const [tipoPeriodoSelected, setTiposPeriodoSelected] = useState([]);
    const [detailsPeriodo, setDetailsPeriodo] = useState([]);
    const [status, setStatus] = useState(null);
    const [period, setPeriod] = useState(null);
    const [reciboNomina, setReciboNomina] = useState(null);
    const [dataCookie, setDataCookie, removeDataCookie] = useCookies("anio_periodo");
    // Nuevo estado para el rango de fechas
    //const [periodoFechaRango, setPeriodoFechaRango] = useState({ inicio: null, fin: null });
    const [periodoSeleccionado, setPeriodoSeleccionado] = useState(null);


    const effectRan = useRef(false);
    useEffect(() => {
        if (!effectRan.current) {
            (async () => {
                await getCatalogs();
            })();
        }
        return () => effectRan.current = true;
    }, []);

    useEffect(() => {
        (async () => {
            if (tipoPeriodoSelected?.value > 0) {
                await getDetailsPeriodo(tipoPeriodoSelected.value);
            }
        })();
    }, [tipoPeriodoSelected]);

    useEffect(() => {
        (async () => {
            if (dataCookie) {
                let values = await form.getFieldsValue();
                var _initialValues = { ...values, ...dataCookie }
                setInitialValues(_initialValues);
                form.setFieldsValue(_initialValues);
                if (_initialValues?.num_periodo > 0) {
                    await getDetailsPeriodo(_initialValues.periodo_id);
                }
            }
        })();
    }, [dataCookie]);

    useEffect(() => {
        (async () => {
            if (tiposPeriodo?.length > 0) {
                let values = await form.getFieldsValue();
                if (values?.periodo_id > 0) {
                    await onChangeTipoPeriodo(values.periodo_id)
                }
            }
        })();
    }, [tiposPeriodo]);

    useEffect(() => {
        (async () => {
            if (detailsPeriodo?.length > 0) {
                await updateStatusAndPeriod();
            }
        })();
    }, [detailsPeriodo]);

    // Nuevo efecto para calcular el rango de fechas cuando cambian los valores relevantes
    useEffect(() => {
        (async () => {
            const values = await form.getFieldsValue();
            if (values.periodo_id && values.anio && values.num_periodo) {
                calcularRangoFechas(values.periodo_id, values.anio, values.num_periodo);
            }
        })();
    }, [tipoPeriodoSelected, form.getFieldValue('anio'), form.getFieldValue('num_periodo')]);

    // Función para calcular el rango de fechas según el tipo de periodo
    const calcularRangoFechas = (periodoId, anio, numPeriodo) => {
        if (!periodoId || !anio || !numPeriodo) return;

        const tipoPeriodo = tiposPeriodo.find(x => x.value == periodoId);
        if (!tipoPeriodo) return;

        const fechaInicio = new Date(anio, 0, 1); // 1ro de enero del año seleccionado
        let fechaFin = new Date(anio, 0, 1);

        // Ajustar según el tipo de periodo y el número
        if (tipoPeriodo.text.toLowerCase().includes('quincenal')) {
            // Para periodos quincenales
            const diasPorPeriodo = 15;
            fechaInicio.setDate(1 + (numPeriodo - 1) * diasPorPeriodo);
            fechaFin = new Date(fechaInicio);
            fechaFin.setDate(fechaInicio.getDate() + diasPorPeriodo - 1);
        } else if (tipoPeriodo.text.toLowerCase().includes('semanal')) {
            // Para periodos semanales
            const diasPorPeriodo = 7;
            fechaInicio.setDate(1 + (numPeriodo - 1) * diasPorPeriodo);
            fechaFin = new Date(fechaInicio);
            fechaFin.setDate(fechaInicio.getDate() + diasPorPeriodo - 1);
        } else if (tipoPeriodo.text.toLowerCase().includes('mensual')) {
            // Para periodos mensuales
            fechaInicio.setMonth(numPeriodo - 1);
            fechaFin = new Date(anio, numPeriodo, 0); // Último día del mes
        } else {
            // Para otros tipos de periodo (por defecto)
            fechaInicio.setDate(1 + (numPeriodo - 1) * 30);
            fechaFin = new Date(fechaInicio);
            fechaFin.setDate(fechaInicio.getDate() + 29);
        }

        // setPeriodoFechaRango({
        //     inicio: fechaInicio,
        //     fin: fechaFin
        // });
    };

    const getCatalogs = async () => {
        const responsePeriodos = await getPeriodos();
        if (responsePeriodos.ok) {
            let items = responsePeriodos.payload;
            setTiposPeriodo(items);
        }
    }

    const getDetailsPeriodo = async (periodId) => {
        let detailsResponse = await getDetailsByPeriodId(periodId);
        if (detailsResponse.ok) {
            let details = detailsResponse.payload;
            setDetailsPeriodo(details);
            if (getPeriodDetails) {
                await getPeriodDetails(details);
            }
        }
    }

    const updateCookie = async () => {
        let values = await form.getFieldsValue();
        var _data = { ...dataCookie };
        _data.periodo_id = values.periodo_id;
        _data.anio = values.anio;
        _data.num_periodo = values.num_periodo;
        setDataCookie(_data)
    }

    const onChangeTipoPeriodo = async (value) => {
        var _tipoPeriodo = tiposPeriodo.find(x => x.value == value)
        if (!_tipoPeriodo) { return; }
        setTiposPeriodoSelected(_tipoPeriodo);
        const values = await form.getFieldsValue();
        await updateCookie();
        await updateStatusAndPeriod();
        calcularRangoFechas(value, values.anio, values.num_periodo);
    }

    const onChangeAnio = async (value) => {
        await updateStatusAndPeriod();
        const values = await form.getFieldsValue();
        calcularRangoFechas(values.periodo_id, value, values.num_periodo);
    }

    const onChangeNumPeriodo = async () => {
        const values = await form.getFieldsValue();
        const periodoExists = await validarPeriodoExiste(values.periodo_id, values.anio, values.num_periodo);
        
        if (!periodoExists) {
            message.error(`El período ${values.num_periodo} no existe para el año ${values.anio}`);
            return;
        }
        
        await updateStatusAndPeriod();
        calcularRangoFechas(values.periodo_id, values.anio, values.num_periodo);
    }

    const validarPeriodoExiste = async (periodoId, anio, numPeriodo) => {
        const numPeriodos = detailsPeriodo.filter((x) => {
            return x.periodo_id == periodoId && x.anio == anio && x.num_periodo == numPeriodo
        });
        return numPeriodos.length > 0;
    }

    const updateStatusAndPeriod = async () => {
        let values = await form.getFieldsValue();
        var numPeriodos = detailsPeriodo.filter((x) => {
            return x.periodo_id == values.periodo_id && x.anio == values.anio
        }).map((x) => {
            return {
                anio: x.anio,
                num_periodo: x.num_periodo,
                status: x.estatus,
                fecha_inicial: x.fecha_inicial,
                fecha_final: x.fecha_final,
                periodoCompleto: x
            };
        });

        if (numPeriodos?.length == 0) {
            return;
        }

        numPeriodos = _.orderBy(numPeriodos, ['anio', 'num_periodo'], ['desc', 'desc']);

        values = await form.getFieldsValue();
        var period = _.find(numPeriodos, { num_periodo: values?.num_periodo });
        if (!period) {
            return;
        }

        var currentStatus = _.find(status_period.list, { value: period.status });
        setStatus(currentStatus);
        setPeriod(period);
        setPeriodoSeleccionado(period.periodoCompleto); // Guardamos el período completo
        await updateCookie();

        if (onBlur) {
            await onBlur(values, period, currentStatus)
        }
    }

    const onClickBack = async () => {
        let values = await form.getFieldsValue();
        var numPeriodos = detailsPeriodo.filter((x) => { return x.periodo_id == values.periodo_id }).map((x) => {
            return { anio: x.anio, num_periodo: x.num_periodo };
        });
        numPeriodos = _.orderBy(numPeriodos, ['anio', 'num_periodo'], ['asc', 'desc']);
        var index = _.findIndex(numPeriodos, (x) => {
            return x.anio == values.anio && x.num_periodo == values.num_periodo
        });

        if (numPeriodos.length >= index && numPeriodos[index + 1]) {
            form.setFieldsValue({
                ...values,
                num_periodo: numPeriodos[index + 1].num_periodo
            });
        }
        await updateStatusAndPeriod();
    }

    const onClickNext = async () => {
        let values = await form.getFieldValue();
        var numPeriodos = detailsPeriodo.filter((x) => { return x.periodo_id == values.periodo_id }).map((x) => {
            return { anio: x.anio, num_periodo: x.num_periodo };
        });
        numPeriodos = _.orderBy(numPeriodos, ['anio', 'num_periodo'], ['asc', 'desc']);
        var index = _.findIndex(numPeriodos, (x) => {
            return x.anio == values.anio && x.num_periodo == values.num_periodo
        });

        if (numPeriodos.length >= index && numPeriodos[index - 1]) {
            form.setFieldsValue({
                ...values,
                num_periodo: numPeriodos[index - 1].num_periodo
            });
        }
        await updateStatusAndPeriod();
    }

    const ComponentRender = () => {
        if (status.value == status_period.sin_calcular)
            return <Tag color={'gray'} key={'sin_calcular'}>
                {'Sin Calcular'}
            </Tag>

        if (status.value == status_period.calculado_parcial)
            return <Tag color={'#2db7f5'} key={'calculado_parcial'}>
                {'Calculado Parcial'}
            </Tag>

        if (status.value == status_period.calculado_total)
            return <Tag color={'#87d068'} key={'calculado_total'}>
                {'Calculado Total'}
            </Tag>
        if (status.value == status_period.cerrado)
            return <Tag color={'#108ee9'} key={'Cerrado'}>
                {'Cerrado'}
            </Tag>

        if (status.value == status_period.timbrado_parcial)
            return <Tag color={'purple'} key={'timbrado_parcial'}>
                {'Timbrado Parcial'}
            </Tag>

        if (status.value == status_period.timbrado_total)
            return <Tag color={'purple'} key={'timbrado_total'}>
                {'Timbrado Total'}
            </Tag>

        return <></>;
    }

    // Función para formatear fechas en formato dd/mm/yyyy
    const formatearFecha = (fecha) => {
        if (!fecha) return '';
        const dia = fecha.getDate().toString().padStart(2, '0');
        const mes = (fecha.getMonth() + 1).toString().padStart(2, '0');
        const anio = fecha.getFullYear();
        return `${dia}/${mes}/${anio}`;
    };

    const formatearFechaAPI = (fechaString) => {
        if (!fechaString) return '';
        const formato = moment(fechaString, "YYYY-MM-DD").format("DD/MM/YYYY"); 
        return formato;
    };

    return (<>
        <Form
            layout="horizontal"
            form={form}
            disabled={disabledForm}
            autoComplete="off"
            initialValues={initialValues}
            onFinish={null}>
            <Flex wrap gap="large">
                <Form.Item
                    name="periodo_id"
                    label="Tipo Periodo"
                    rules={[
                        {
                            required: false,
                            message: 'Por favor selecciona un tipo de periodo',
                        },
                    ]}
                >
                    <Select placeholder="Por favor selecciona un tipo de periodo" onChange={onChangeTipoPeriodo}>
                        {
                            tiposPeriodo.map((item) => <Option key={item.value} value={item.value}>{item.text}</Option>)
                        }
                    </Select>
                </Form.Item>
                <Form.Item
                    name="anio"
                    label="Año"
                    rules={[
                        {
                            required: false,
                            message: '',
                        },
                    ]}
                >
                    <InputNumber placeholder="Por favor agrega un año" onBlur={onChangeAnio} />
                </Form.Item>
                <Form.Item
                    name="num_periodo"
                    label="Num Periodo"
                    rules={[
                        {
                            required: false,
                            message: '',
                        },
                    ]}
                >
                    <InputNumber 
                        placeholder="Por favor agrega un número de periodo" 
                        onBlur={onChangeNumPeriodo}
                        onPressEnter={onChangeNumPeriodo}
                    />
                </Form.Item>
                <Button icon={<ArrowLeftOutlined />} type="text" iconPosition={'start'} onClick={onClickBack}></Button>
                <Button icon={<ArrowRightOutlined />} type="text" iconPosition={'start'} onClick={onClickNext}></Button>



                {/* Nuevo campo para mostrar el rango de fechas */}
                {periodoSeleccionado && periodoSeleccionado.fecha_inicial && periodoSeleccionado.fecha_final && (
                    <Form.Item label="Fecha Periodo">
                        <Tag color="blue">
                            {`${formatearFechaAPI(periodoSeleccionado.fecha_inicial)} - ${formatearFechaAPI(periodoSeleccionado.fecha_final)}`}
                        </Tag>
                    </Form.Item>
                )}

                {status && <span><ComponentRender /></span>}
            </Flex>
        </Form>
    </>);
});
export default AnioPeriodo;